import React from 'react';
import AdmInventoryCategory from '../../components/AdminTabs/AdmInventoryCategory/AdmInventoryCategory';

const InventoryCategory = () => {
  return (
    <div>
      <AdmInventoryCategory />
    </div>
  );
};

export default InventoryCategory;
